import { API_CONSTANT_MAP } from "./paths";
import requestApi from "./requestApi";

export const getPerfis = async () => {
  const url = API_CONSTANT_MAP.perfil;
  return requestApi.get(url);
};

export const getPerfilById = async (id: string | number) => {
  const url = `${API_CONSTANT_MAP.perfil}/${id}`;
  return requestApi.get(url);
};

export const postPerfil = async (payload: any) => {
  const url = API_CONSTANT_MAP.perfil;
  return requestApi.post(url, payload);
};
